function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import UserDetails from "./UserDetails";
import "./polizaDetails.scss";
import { FaAngleUp, FaAngleDown, FaAngleLeft, FaTrashAlt, FaPen, FaEye } from "react-icons/fa";
import MateriaAseguradaDetails from "./MateriaAseguradaDetails/MateriaAseguradaDetails";
import PaymentMethodDetails from "./PaymentMethodDetails/PaymentMethodDetails";
export var UserType;

(function (UserType) {
  UserType[UserType["Contratante"] = 0] = "Contratante";
  UserType[UserType["Asegurado"] = 1] = "Asegurado";
  UserType[UserType["Beneficiario"] = 2] = "Beneficiario";
})(UserType || (UserType = {}));

var userTypes = [{
  type: UserType.Contratante,
  title: "Contratante",
  polizaName: "contratante"
}, {
  type: UserType.Asegurado,
  title: "Asegurado",
  polizaName: "asegurado"
}, {
  type: UserType.Beneficiario,
  title: "Beneficiario",
  polizaName: "beneficiario"
}];

var PolizaDetails = function PolizaDetails(props) {
  var _poliza$company, _poliza$item_asegurad;

  var poliza = props.poliza,
      admin = props.admin;

  var _React$useState = React.useState([UserType.Contratante]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeUserTypes = _React$useState2[0],
      setActiveUserTypes = _React$useState2[1];

  var handleUserTypeClick = function handleUserTypeClick(userType) {
    if (activeUserTypes.includes(userType)) {
      setActiveUserTypes(activeUserTypes.filter(function (type) {
        return type !== userType;
      }));
    } else {
      setActiveUserTypes([].concat(_toConsumableArray(activeUserTypes), [userType]));
    }
  };

  var canUserDo = function canUserDo(action) {
    var _admin$permissions_co;

    return (admin === null || admin === void 0 ? void 0 : (_admin$permissions_co = admin.permissions_code) === null || _admin$permissions_co === void 0 ? void 0 : _admin$permissions_co.includes(action)) || admin.is_super_admin;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card cntPolizaDetails"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-7"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("b", null, "Detalle"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn btn-info",
    target: "_blank",
    href: "/admin/polizas/".concat(poliza.id, "/preview")
  }, /*#__PURE__*/React.createElement(FaEye, null), " Vista Previa")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, canUserDo("poliza_edit") && /*#__PURE__*/React.createElement("a", {
    className: "btn btn-warning",
    href: "/admin/polizas/".concat(poliza.id, "/edit")
  }, /*#__PURE__*/React.createElement(FaPen, null), " Editar")))), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, !(poliza !== null && poliza !== void 0 && poliza.document) && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger",
    role: "alert"
  }, /*#__PURE__*/React.createElement("span", {
    className: "glyphicon glyphicon-list-alt"
  }), "\xA0La poliza no cuenta con un documento de poliza para ser adjuntado en el correo."), !(poliza !== null && poliza !== void 0 && poliza.general_condition) && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger"
  }, /*#__PURE__*/React.createElement("span", {
    className: "glyphicon glyphicon-warning-sign"
  }), "\xA0La poliza no cuenta con las condiciones generales o las condiciones generales no posee un documento para ser adjuntado en el correo."), !(poliza !== null && poliza !== void 0 && poliza.assist_card) && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement("span", {
    className: "glyphicon glyphicon-phone"
  }), "\xA0La poliza no cuenta con la tarjeta de asistencia para ser adjuntada en el correo."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Compa\xF1\xEDa"), /*#__PURE__*/React.createElement("td", null, ((_poliza$company = poliza.company) === null || _poliza$company === void 0 ? void 0 : _poliza$company.name) || "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Ramo"), /*#__PURE__*/React.createElement("td", null, poliza.ramo || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Inicio vigencia"), /*#__PURE__*/React.createElement("td", null, poliza.start_date || "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Fin vigencia"), /*#__PURE__*/React.createElement("td", null, poliza.finish_date || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Fecha de emisi\xF3n"), /*#__PURE__*/React.createElement("td", null, poliza.emission_date || "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "CMF"), /*#__PURE__*/React.createElement("td", null, poliza.general_condition_code || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Renovaci\xF3n ?"), /*#__PURE__*/React.createElement("td", null, poliza.renewal ? "SI" : "NO"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "N\xBA Poliza anterior"), /*#__PURE__*/React.createElement("td", null, poliza.old_poliza_code || "-")))), userTypes.map(function (userType) {
    return /*#__PURE__*/React.createElement("div", {
      key: userType
    }, /*#__PURE__*/React.createElement("h5", {
      onClick: function onClick() {
        return handleUserTypeClick(userType.type);
      },
      className: "userTypes-title"
    }, activeUserTypes.includes(userType.type) ? /*#__PURE__*/React.createElement(FaAngleUp, null) : /*#__PURE__*/React.createElement(FaAngleDown, null), userType.title), activeUserTypes.includes(userType.type) && /*#__PURE__*/React.createElement(UserDetails, {
      user: poliza[userType.polizaName]
    }));
  }), /*#__PURE__*/React.createElement("h4", {
    className: "sub-tables-title"
  }, "Materia Asegurada ", poliza !== null && poliza !== void 0 && poliza.ramo ? "(".concat(poliza.ramo, ")") : ""), /*#__PURE__*/React.createElement("div", null, poliza === null || poliza === void 0 ? void 0 : (_poliza$item_asegurad = poliza.item_asegurados) === null || _poliza$item_asegurad === void 0 ? void 0 : _poliza$item_asegurad.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement("h5", {
      className: "sub-tables-title"
    }, "Item ", index + 1), /*#__PURE__*/React.createElement(MateriaAseguradaDetails, {
      itemAsegurado: item,
      ramo: poliza.ramo,
      currency: poliza.currency
    }));
  })), /*#__PURE__*/React.createElement("h4", {
    className: "sub-tables-title"
  }, "M\xE9todo de Pago", " ", poliza !== null && poliza !== void 0 && poliza.tipo_de_pago ? "(".concat(poliza.tipo_de_pago, ")") : ""), /*#__PURE__*/React.createElement(PaymentMethodDetails, {
    poliza: poliza
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "sub-tables-title"
  }, "Documentos"), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Poliza"), /*#__PURE__*/React.createElement("td", null, (poliza === null || poliza === void 0 ? void 0 : poliza.document) && /*#__PURE__*/React.createElement("a", {
    href: poliza.document,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-file"
  }, "Poliza")))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Condiciones Generales"), /*#__PURE__*/React.createElement("td", null, (poliza === null || poliza === void 0 ? void 0 : poliza.document) && /*#__PURE__*/React.createElement("a", {
    href: poliza.general_condition,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-file"
  }, poliza.general_condition_code)))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Tarjeta de asistencia"), /*#__PURE__*/React.createElement("td", null, (poliza === null || poliza === void 0 ? void 0 : poliza.assist_card) && /*#__PURE__*/React.createElement("a", {
    href: poliza.assist_card,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-file"
  }, "Tarjeta de asistencia")))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Archivos Adicionales"), /*#__PURE__*/React.createElement("td", null, (poliza === null || poliza === void 0 ? void 0 : poliza.additional_files) && (poliza === null || poliza === void 0 ? void 0 : poliza.additional_files.length) > 0 && (poliza === null || poliza === void 0 ? void 0 : poliza.additional_files.map(function (additionalFile, index) {
    var _additionalFile$file;

    return /*#__PURE__*/React.createElement("a", {
      href: additionalFile === null || additionalFile === void 0 ? void 0 : (_additionalFile$file = additionalFile.file) === null || _additionalFile$file === void 0 ? void 0 : _additionalFile$file.url,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("i", {
      className: "glyphicon glyphicon-file"
    }, index + 1));
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-actions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-default",
    onClick: function onClick() {
      return window.history.back();
    }
  }, /*#__PURE__*/React.createElement(FaAngleLeft, null), " Volver")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, canUserDo("poliza_OP") && /*#__PURE__*/React.createElement("a", {
    "data-confirm": "Est\xE1s seguro de querer borrar la p\xF3liza?",
    className: "btn btn-danger",
    rel: "nofollow",
    "data-method": "delete",
    href: "/admin/polizas/".concat(poliza.id)
  }, /*#__PURE__*/React.createElement(FaTrashAlt, null), " Borrar"))))));
};

export default PolizaDetails;